import { AutoMap } from "@automapper/classes";

export class Contract {

    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: String;
}
